export const URL = {
  LOBBY: '/lobby',
  GAME: '/',
} as const;
